<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش کاردکس کالا</h5>
        <div style="flex: 1"></div>
        <ExcelDownload class="mr-3" :url="excelUrl" />
        <button @click="print" class="btn btn-primary mr-1">
            <span
                style="transform: translateY(3px)"
                class="feather-printer"
            ></span>
        </button>
      </div>
      <div class="row px-4 not-in-print">
        <form
          autocomplete="new-password"
          @submit.prevent="doFilter"
          class="col-12 row"
        >
          <div class="col-6">
            <DatePickerRange v-model="filter.date" />
          </div>
          <b-form-group class="col-3 ">
            <b-form-input v-model="from_id" placeholder="از شناسه فاکتور" />
          </b-form-group>
          <b-form-group class="col-3 ">
            <b-form-input v-model="to_id" placeholder="تا شناسه فاکتور" />
          </b-form-group> 
          <div class="row col-12">
            <b-form-group class="col-6">
              <multiselect
                placeholder="انتخاب انبار"
                v-model="selectedStore"
                open-direction="bottom"
                :options="stores"
                label="label"
                track-by="id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :disabled="disabled"
              >
                <template slot="noOptions"> موردی یافت نشد </template>
                <template slot="noResult"> موردی یافت نشد </template>
              </multiselect>
            </b-form-group>
            <b-form-group class="col-6">
              <treeselect
                  placeholder="انتخاب دسته بندی"
                  :options="realOptions"
                  v-model="categoryId"
                  :searchable="true"
                  :show-count="true"
                  noChildrenText="فرزندی وجود ندارد"
                  noOptionsText="موردی وجود ندارد"
                  noResultsText="موردی یافت نشد"
                  :default-expand-level="1"
                  label="title"
              >
                  <label
                  slot="option-label"
                  slot-scope="{
                      node,
                      shouldShowCount,
                      count,
                      labelClassName,
                      countClassName,
                  }"
                  :class="labelClassName"
                  >
                  {{ node.label }}
                  </label>
              </treeselect>
            </b-form-group>
          </div>
          <ProductSearch
            class="row col-md-12"
            ref="productSearch"
            :selectable="true"
            :store="selectedStore"
            :disabled="disabled"
            @selectProduct="selectProduct"
            :show-label="false"
            @selectVariety="selectVariety"
          />
          <div class="row col-md-12">
            <b-form-group class="col-md-6">
              <div class="d-flex">
                <label
                  class="ml-2"
                  >مرجوعی ها</label
                >
                <b-form-checkbox
                  :unchecked-value="0"
                  :disabled="disabled"
                  :value="1"
                  v-model="type_refund"
                />
              </div>
          </b-form-group>
          </div>
          <div class="col-12 d-flex justify-content-start">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
          </div>
        </form>
      </div>

      <div id="print" class="p-4">  
          <div class="print-only">  
              <h4>فروشگاه پاشیک</h4>  
          </div>  
          <br>  
          <div class="d-flex mb-3 mr-2-print">  
              <span class="ml-1 font-bold print-only">گزارش کاردکس کالا</span>  
              <div v-if="appliedFilter.date.startDate" class="print-only">  
                <span>از</span>
                <span class="font-weight-bold mx-1">تاریخ</span
                    ><span> {{ appliedFilter.date.startDate | persianDate }}</span>
                </div>
              <div class="mr-3" v-if="appliedFilter.date.endDate">
                  <span>تا</span>
                  <span class="font-weight-bold mx-1">تاریخ</span
                  ><span>{{ appliedFilter.date.endDate | persianDate }} </span>
              </div>
          </div>  
          <b-table  
            id="main-table"  
            v-if="reports"  
            bordered  
            striped  
            :fields="fields"  
            :items="reports"  
            responsive="sm"  
          >  
            <template v-slot:cell(index)="data">  
              {{ data.index + 1 }}  
            </template>  
            <template v-slot:cell(variety_title)="data">  
              {{ data.item.variety_title }}  
            </template>  

            <template #bottom-row="data">  
              <b-td role="cell">*</b-td>  
              <b-td role="cell">*</b-td>  
              <b-td role="cell">جمع کل:</b-td>  
              <b-td role="cell">  
                {{ totals.quantity | price }}  
              </b-td>  
            </template>  
          </b-table>  

          <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>  
      </div>  
    </div>
  </main>
</template>

<script>
import {BTooltip, BTable, BFormGroup, BFormInput, BFormCheckbox, BTd, VBToggle, VBTooltip} from "bootstrap-vue";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ShowVarietiesModal from "@@/core/components/report/ShowVarietiesModal";
import Dropdown from "@@/core/components/shared/Dropdown/Dropdown";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import configProvider from "@@/core/configProvider";
import Treeselect from "@riophae/vue-treeselect";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
import mixins from '@@/core/mixins/mixins'
import reportMixin from "@@/core/mixins/reportMixin";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload";

function Filter() {
  this.reportType = "";
  this.search = "";
  this.date = {
    startDate: "",
    endDate: "",
  };
}

Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "cardexReport",
  mixins: [mixins],
  components: {
    Dropdown,
    ShowVarietiesModal,
    DatePickerRange,
    ProductSearch,
    Treeselect,
    BFormCheckbox,
    BTable,
    ExcelDownload,
    BFormGroup,
    BTooltip,
    BTd,
    BFormInput,
  },
  directives: {
    'b-toggle': VBToggle, 'b-tooltip': VBTooltip,
  },
  configProvider,
  data() {
    return {
      totals: null,
      disabled: true,
      search: "",
      to_id: "",
      from_id: "",
      fields: [
        {
          key: "index",
          label: "ردیف",
        },
        {
          key: "type",
          label: "نوع",
        },
        {
          key: "variety_title",
          label: "عنوان محصول",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
      ],
      page: 1,
      reports: [],
      list: [],
      sortBy: null,
      categories: [],
      sortDesc: null,
      Variety_id: "",
      Product_id: "",
      type_refund: false,
      filter: new Filter(),
      selectedStore: null,
      stores: [],
      appliedFilter: new Filter(),
      showVarietiesProductId: null,
      categoryId: null,
      sumTotalSale: null,
      sumSellQuantity: null,
      widgetData: {},
    };
  },
  mixins: [reportMixin],

  created() {
    this.loadStores();
    this.loadCategories();
  },
  methods: {
    showMore() {
      this.reports.push(
        ...this.list.slice(this.reports.length, this.reports.length + 100)
      );
    },
    selectVariety(data) {
      this.Variety_id = data;
    },
    selectProduct(data) {
      this.Product_id = data;
    },
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },
    print() {  
        window.print();  
    },  
    doFilter() {
      this.showVarietiesProductId = null;
      this.loadData();
    },
    async loadStores(){
      try {
          const response = await this.$axios.get("admin/stores");
          this.stores = response.data.data.stores;
          this.disabled = false;
      } catch (e) {
          this.$root.notify(e);
      } 
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    catHelper(item) {
      let list = [];
      item.children.forEach((child) => {
        if (child.children.length) {
          list.push(child);
          list.push(...this.catHelper(child));
        } else {
          list.push(child);
        }
      });
      return list;
    },
    async loadCategories(){
        try {
            const response = await this.$axios.get("admin/categories?all=1");
            this.categories = response.data.data.categories;
            this.disabled = false;
        } catch (e) {
            this.$root.notify(e);
        } 
    },
    async loadData() {  
        this.appliedFilter.set(this.filter);  
        this.disabled = false;  
        const response = await this.$axios.get("admin/reports/cardex-new", {  
          params: {  
            from_id: this.from_id,  
            to_id: this.to_id,  
            type: this.type_refund ? "refund" : "sell",
            start_date: this.appliedFilter.date.startDate,  
            end_date: this.appliedFilter.date.endDate,  
            category_id: this.categoryId == 0 ? null : this.categoryId,
            store_id: this.selectedStore ? this.selectedStore.id : '',
            product_id: this.Product_id.id ? this.Product_id.id : '',
            variety_id: this.Variety_id.id ? this.Variety_id.id : '',
          },  
        });  
        this.reports = response.data.data.reports;  
        this.totals = response.data.data.totals;  
    },
    showVarieties(productId) {
      this.$root.$emit("bv::show::modal", "show-varieties-modal");
      this.showVarietiesProductId = productId;
    },
  },
  computed: {
    excelUrl() {
      const params = {
        from_id: this.from_id ?? "",  
        to_id: this.to_id ?? "",  
        start_date: this.appliedFilter.date.startDate,  
        end_date: this.appliedFilter.date.endDate, 
        category_id: this.categoryId == 0 || !this.categoryId ? '' : this.categoryId,
        store_id: this.selectedStore ? this.selectedStore.id : '',
        product_id: this.Product_id ? this.Product_id.id : '',
        variety_id: this.Variety_id ? this.Variety_id.id : '',
      };

      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join('&');

      return `admin/reports/cardex-new?${queryString}`;
    },
    realOptions() {
      let temp = this.$root.addLabel(this.categories);
      temp.unshift({
          label: "ندارد",
          children: [],
          id: 0,
      });

      return temp;
    },
    typesOptions() {
      return [
        { name: "", label: "همه" },
        { name: "online", label: "آنلاین" },
        { name: "offline", label: "حضوری" },
        { name: "sari", label: "ساری" },
      ];
    },
    reportTypeCode() {
      switch (this.filter.reportType) {
        case "online":
          return 0;
        case "":
          return 2;
        case "offline":
          return 1;
      }
    },
    extraQuery() {
      return {
        type: this.filter.reportType,
        start_date: this.filter.date.startDate,
        end_date: this.filter.date.endDate,
      };
    },
  },
};
</script>

<style>  
.print-only {  
    display: none;  
}  

@media print {  
    .not-in-print {  
        display: none !important;  
    }  

    .app-content .side-app {  
        padding: 0 !important;  
    }  

    body * {  
        visibility: hidden;  
    }  
    .print-only {
      display: flex;
      justify-content: center; 
    }
    #print,  
    #print * {  
        visibility: visible;  
        font-size: 1.25rem;  
    }  

    #print {  
        padding: 0 !important;  
        width: 100%;  
    }  

    .mr-2-print {  
        margin-right: 20px;  
    }  
}  
</style>  